export const COLUMNS = [
    {
        Header: "Name",
        Footer: "Name",
        accessor: "name",
        sticky: "left",
    },
    {
        Header: "Mobile",
        Footer: "Mobile",
        accessor: "mobile",
    },
    {
        Header: "Order",
        Footer: "Order",
        accessor: "redemption_type",
    },
    {
        Header: "Order Code",
        Footer: "Order Code",
        accessor: "ordercode",
    },
    {
        Header: "Order Value",
        Footer: "Order Value",
        accessor: "ordervalue",
    },
    {
        Header: "Title",
        Footer: "Title",
        accessor: "title",
        Cell: ({ value }) => (
            <div className="d-flex flex-wrap gap-1">
                {value}
            </div>
        ),
    },
    {
        Header: "Date",
        Footer: "Date",
        accessor: "transactionDate",
    },
    {
        Header: "Action",
        Footer: "Action",
        accessor: "action",
    },
];

export const MOVO_COLUMNS = [
  {
    Header: "Name",
    Footer: "Name",
    accessor: "firstname",
    sticky: "left",
  },
  {
    Header: "Mobile",
    Footer: "Mobile",
    accessor: "mobile",
  },
  {
    Header: "Point",
    Footer: "Point",
    accessor: "point",
  },
  {
    Header: "Date",
    Footer: "Date",
    accessor: "transactionDate",
  },
   {
    Header: "Action",
    Footer: "Action",
    accessor: "action",
  },
];

export const MOVO_VOUCHER_COLUMNS = [
  {
    Header: "Name",
    Footer: "Name",
    accessor: "name",
    sticky: "left",
  },
  {
    Header: "Mobile",
    Footer: "Mobile",
    accessor: "mobile",
  },
  {
    Header: "Voucher Code",
    Footer: "Voucher Code",
    accessor: "vouchercode",
  },
  {
    Header: "Voucher Name",
    Footer: "Voucher Name",
    accessor: "voucherName",
  },
  {
    Header: "Value",
    Footer: "Value",
    accessor: "value",
  },
  {
    Header: "Expiry Date",
    Footer: "Expiry Date",
    accessor: "expiredate",
  },
];